<template>
    <div
        class="input-challenge-select-user-username">
        <svg class="input-challenge-select-user-username__icon" width="18" height="18" viewBox="0 0 18 18" fill="#000" fill-opacity=".3" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 2a5 5 0 100 10A5 5 0 007 2zM0 7a7 7 0 1112.606 4.192l5.101 5.1a1 1 0 01-1.414 1.415l-5.1-5.1A7 7 0 010 7z"/></svg>
        <input
            type="text" placeholder="ara"
            class="input-challenge-select-user-username__input"
            @input="input">
        <button
            v-if="showBtnClear"
            class="btn-input-challenge-select-user-username-clear"
            @click="clearInput">
            <svg class="btn-input-challenge-select-user-username-clear__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#prefix__clip0_843_4945)"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.829 10.12a.501.501 0 11-.707.71L8.002 8.71 5.87 10.845a.508.508 0 01-.713 0 .507.507 0 010-.715L7.29 7.995 5.172 5.88a.5.5 0 11.707-.71l2.118 2.12 2.149-2.15a.507.507 0 01.712 0c.197.2.197.515 0 .715L8.71 8.005l2.118 2.115zM8 0C3.582 0 0 3.58 0 8s3.582 8 8 8 8-3.58 8-8-3.582-8-8-8z" fill="#C3C2D3"/></g><defs><clipPath id="prefix__clip0_843_4945"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>
        </button>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        data(){
            return {
                timeoutId: null,
            };
        },

        computed: {
            showBtnClear(){
                return this.$store.state.input.challengeSelectUser.username ? true : false;
            },
        },

        methods: {
            input(event){
                if(this.timeoutId){
                    clearTimeout(this.timeoutId);
                }
                this.timeoutId = setTimeout(() => {
                    this.$store.commit('setInputChallengeSelectUserUsername', event.target.value);
                    this.$store.commit('setChallengeSelectUserSearchedUserItems', []);
                    if(!this.$store.state.input.challengeSelectUser.username){
                        this.$emit('clearInput');
                        return false;
                    }
                    this.$emit('newInput');
                }, 1000);
            },

            clearInput(){
                this.$store.commit('setInputChallengeSelectUserUsername', '');
                this.$store.commit('setChallengeSelectUserSearchedUserItems', []);
                document.querySelector('.input-challenge-select-user-username__input').value = '';
                this.$emit('clearInput');
            }
        }
    };
</script>

<style scoped src="@/css/components/input-challenge-select-user-username.css"></style>